import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { RootState } from 'Store'
import { cloneDeep } from 'lodash'
import { Col, Descriptions, Divider, Image, Row, Space } from 'antd'
import { PrimaryButton } from 'Components/button'
import { isFormRequired, isFormError, formValidation, numberWithComma } from 'helpers/format'
import { PickUpProduct, PurchaseProduct } from 'Store/purchase/types'
import {
  selectPurchaseActionEvent,
  selectPurchaseDetail,
  selectPurchaseDetailEvent,
} from 'Store/purchase/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { AppInput } from 'Components/form'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { appConfig, themeConfig } from 'config'
import { ImageFallback } from 'helpers/constanst'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  mode: any
  product?: PickUpProduct
  onSave?: (product: PickUpProduct) => void
}

const PickUpForm: React.FunctionComponent<Props> = props => {
  const { onCloseDrawer, visible, detailEvent, product, onSave = () => {} } = props
  const requireFeild = [
    'received_amout',
    //'percent'
  ]
  const initForm = {
    ...cloneDeep(product),
  } as PickUpProduct
  const [formData, setFormData] = useState(cloneDeep(initForm))
  const [formError, setFormError] = useState([] as string[])
  const purchaseInfo = product?.purchase_info
  const uom = purchaseInfo?.product_uom || ''
  const remain = (purchaseInfo?.amount || 0) - (purchaseInfo?.received_amount || 0)
  const enableProductOnline = themeConfig?.component?.elementOnlineProduct

  useEffect(() => {
    // clear form data when user cloase drawer
    if (!visible) {
      setFormData(cloneDeep(initForm))
      setFormError([])
    }

    return () => {
      setFormData({ ...initForm })
    }
  }, [visible])

  useEffect(() => {
    const form = {
      ...cloneDeep(product),
    } as PickUpProduct
    setFormData({ ...form })
  }, [product])

  useEffect(() => {
    if (formError.length > 0) {
      validateForm()
    }
  }, [formData])

  const validateForm = () => {
    const error = formValidation(requireFeild, formData)
    setFormError([...error])
    return error.length > 0 ? false : true
  }

  const onClickSave = (): void => {
    if (!validateForm()) {
      return
    }
    onSave({ ...formData, percent: formData?.percent || 0 })
    onCloseDrawer()
  }

  const onUpdateData = (val: any, key: string) => {
    if (key === 'received_amout') {
      let recieve = parseInt(val)
      if (recieve > remain) {
        recieve = remain
      }
      setFormData({
        ...formData,
        [key]: recieve,
      })
      return
    }

    if (key === 'percent') {
      let percent = parseInt(val)
      if (percent > 100) {
        percent = 100
      }
      setFormData({
        ...formData,
        [key]: percent,
      })
      return
    }

    setFormData({
      ...formData,
      [key]: val,
    })
  }

  const isRequired = (name: string) => {
    return isFormRequired(requireFeild, name)
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  const FooterContent = (
    <Space size="middle" align="baseline">
      <Space size="middle" align="baseline">
        <PrimaryButton text="ยกเลิก" btnType="Cancel" onClick={onCloseDrawer} />
        <PrimaryButton text="บันทึก" onClick={onClickSave} />
      </Space>
    </Space>
  )

  const renderProductName = (record?: PurchaseProduct) => {
    const isSameTitle = record?.product_name == record?.product_option_name
    return (
      <Space direction="vertical" size="small">
        {record?.product_name}
        {!isSameTitle && <ProductDesc>{record?.product_option_name}</ProductDesc>}
      </Space>
    )
  }

  const renderImage = (photo: any) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + photo} fallback={ImageFallback} />
  )

  return (
    <DetailDrawer
      title={'รับสินค้าเข้าคลังสินคัา'}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={FooterContent}
      width={'80%'}
    >
      <LoadingView isShow={detailEvent.IsLoading} />
      <Row justify="space-between" gutter={[16, 32]}>
        <Col
          md={24}
          xs={24} // style={{ backgroundColor: theme.colors.whitebg, padding: '0 20px' }}
        >
          <BoxWrapper>
            <Row justify="center" gutter={[16, 16]} align="middle">
              {/* <Col md={24} xs={24}>
                <Space direction="vertical" size="small">
                  <Badge color={theme.colors.primary} text={`จำนวนคงเหลือปัจจุบัน : 10 ${uom}`} />
                  <ProductRemain>
                    <Badge color={theme.colors.primary} />
                    {`จำนวนสินค้าค้างรับ = ${remain} ${uom}`}
                  </ProductRemain>
                </Space>
              </Col> */}
              <Col>{renderImage(purchaseInfo?.product_photo || '')}</Col>
              <Col span={20}>
                <Descriptions bordered size="small">
                  <Descriptions.Item label="ชื่อสินค้า" span={3}>
                    {renderProductName(purchaseInfo)}
                  </Descriptions.Item>
                  <Descriptions.Item label="รหัสสินค้า" span={3}>
                    {purchaseInfo?.product_sku}
                  </Descriptions.Item>
                  <Descriptions.Item label="ราคาต่อหน่วย" span={2}>
                    {numberWithComma(purchaseInfo?.price_per_unit || 0, true)} บาท
                  </Descriptions.Item>
                  <Descriptions.Item label="หน่วย" span={2}>
                    {purchaseInfo?.product_uom}
                  </Descriptions.Item>
                  <Descriptions.Item label="จำนวนคงเหลือปัจจุบัน" span={2}>
                    {purchaseInfo?.product_quantity || 0} {uom}
                  </Descriptions.Item>
                  <Descriptions.Item label="จำนวนสินค้าค้างรับ" span={2}>
                    <ProductRemain>
                      {remain} {uom}
                    </ProductRemain>
                  </Descriptions.Item>
                </Descriptions>
              </Col>
              <Divider />
              <Col md={24} xs={24}>
                <AppInput
                  name="received_amout"
                  label="จำนวนรับเข้า"
                  isRequired={isRequired('received_amout')}
                  isError={isError('received_amout')}
                  value={formData.received_amout}
                  onChange={onUpdateData}
                  type="number"
                  resProps={{
                    suffix: uom,
                  }}
                />
              </Col>
              {enableProductOnline && (
                <Col md={24} xs={24}>
                  <AppInput
                    name="percent"
                    label="เปอร์เซ็นต์ขายบนสต๊อกออนไลน์"
                    isRequired={isRequired('percent')}
                    isError={isError('percent')}
                    value={formData.percent}
                    onChange={onUpdateData}
                    type="number"
                    resProps={{ suffix: '%' }}
                  />
                </Col>
              )}
              <Col md={24} xs={24}>
                <AppInput
                  name="hidden_cost"
                  label="ต้นทุนแฝง"
                  isRequired={isRequired('hidden_cost')}
                  isError={isError('hidden_cost')}
                  value={formData.hidden_cost}
                  onChange={onUpdateData}
                  type="number"
                  resProps={{ suffix: 'บาท' }}
                />
              </Col>
            </Row>
          </BoxWrapper>
        </Col>
        {/* <Col md={16} xs={24}>
          <BoxTitle>ข้อมูลราคาสินค้า</BoxTitle>
          <BoxWrapper>
            <Row justify="space-between" gutter={[8, 8]}>
              <Col md={12} xs={24}>
                <AppInput
                  name="cost_per_unit"
                  label="ราคาต้นทุน/ต่อชิ้น"
                  isRequired={isRequired('cost_per_unit')}
                  isError={isError('cost_per_unit')}
                  value={formData.cost_per_unit}
                  onChange={onUpdateData}
                  resProps={{ suffix: 'บาท', disabled: true }}
                />
              </Col>
              <Col md={12} xs={24}>
                <AppInput
                  name="hidden_cost"
                  label="ต้นทุนแฝง"
                  isRequired={isRequired('hidden_cost')}
                  isError={isError('hidden_cost')}
                  value={formData.hidden_cost}
                  onChange={onUpdateData}
                  type="number"
                  resProps={{ suffix: 'บาท' }}
                />
              </Col>
              <Col md={12} xs={24}>
                <AppInput
                  name="cost"
                  label="ราคาต้นทุน"
                  isRequired={isRequired('cost')}
                  isError={isError('cost')}
                  value={formData.cost}
                  onChange={onUpdateData}
                  type="number"
                  resProps={{ suffix: 'บาท', disabled: true }}
                />
              </Col>
              <Col md={12} xs={24}>
                <AppInput
                  name="cost_average"
                  label="ต้นทุนเฉลี่ย"
                  isRequired={isRequired('cost_average')}
                  isError={isError('cost_average')}
                  value={formData.cost_average}
                  onChange={onUpdateData}
                  type="number"
                  resProps={{ suffix: 'บาท', disabled: true }}
                />
              </Col>
              <Col md={12} xs={24}>
                <AppInput
                  name="online_price"
                  label="ราคาขายออนไลน์"
                  isRequired={isRequired('online_price')}
                  isError={isError('online_price')}
                  value={formData.online_price}
                  onChange={onUpdateData}
                  type="number"
                  resProps={{ suffix: 'บาท' }}
                />
              </Col>
              <Col md={12} xs={24}>
                <AppInput
                  name="offline_price"
                  label="ราคาขายออฟไลน์"
                  isRequired={isRequired('offline_price')}
                  isError={isError('offline_price')}
                  value={formData.offline_price}
                  onChange={onUpdateData}
                  type="number"
                  resProps={{ suffix: 'บาท' }}
                />
              </Col>
              <Col md={12} xs={24}>
                <AppInput
                  name="a_price"
                  label="ราคา A (ขายส่งเงินสด)"
                  isRequired={isRequired('a_price')}
                  isError={isError('a_price')}
                  value={formData.a_price}
                  onChange={onUpdateData}
                  type="number"
                  resProps={{ suffix: 'บาท' }}
                />
              </Col>
              <Col md={12} xs={24}>
                <AppInput
                  name="b_price"
                  label="ราคา B (ขายส่งเครดิต)"
                  isRequired={isRequired('b_price')}
                  isError={isError('b_price')}
                  value={formData.b_price}
                  onChange={onUpdateData}
                  type="number"
                  resProps={{ suffix: 'บาท' }}
                />
              </Col>
              <Col md={12} xs={24}>
                <AppInput
                  name="c_price"
                  label="ราคา C (ปลีกเงินสด , ผู้รับเหมา)"
                  isRequired={isRequired('c_price')}
                  isError={isError('c_price')}
                  value={formData.c_price}
                  onChange={onUpdateData}
                  type="number"
                  resProps={{ suffix: 'บาท' }}
                />
              </Col>
            </Row>
          </BoxWrapper>
        </Col> */}
      </Row>
    </DetailDrawer>
  )
}

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const ProductRemain = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

const RowTile = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body2};
`

const ProductDesc = styled(RowTile)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 100px;
  height: 100px;
  object-fit: cover;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectPurchaseActionEvent(state),
    detail: selectPurchaseDetail(state),
    detailEvent: selectPurchaseDetailEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(PickUpForm)
